import { render, staticRenderFns } from "./OrgProfile.vue?vue&type=template&id=b2a9409c&scoped=true&"
import script from "./OrgProfile.vue?vue&type=script&lang=js&"
export * from "./OrgProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a9409c",
  null
  
)

export default component.exports